export default "__VITE_ASSET__DKdXp$KI__"